/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './RoofDetails.metadata.json5';
import messages from '../Construction.messages';


function RoofDetails(props) {
    const { item, saveData, cancelData, isInvalid, showErrors, onValidate } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [modalItem, updateModalItem] = useState(item);
    const { refreshData } = useDataRefresh();
    const [displayError, setDisplayError] = useState(false);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('RoofDetails');
    const [dateMismatchValidationMessage, setDateMismatchValidationMessage] = useState([]);
    
    const errorHandling = useCallback(() => {
        if(!displayError) { setDisplayError(true) }
        if(_.isUndefined(item.roofUpdateDate.value)){
            setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
        } else {
            setDateMismatchValidationMessage([]);
        }
    }, [displayError] );

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'RoofDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        isInvalid(isComponentValid, 'RoofDetails')
    }, [isComponentValid, isInvalid]);
    
    const writeValue = useCallback(
        (value, path) => {
            setDateMismatchValidationMessage([]);
            // DE15526
            if (path === 'roofUpdateDate') {
                if (!_.isUndefined(value) && !_.isUndefined(value.year) && value.year < 1988) {
                    _.set(modalItem, 'hasWPI8CertOfCompIssued_TWIA', undefined);
                }
                if (_.isUndefined(value)) { // DE17424
                    setDateMismatchValidationMessage([translator(messages.dateMustmatch)]);
                }
            }
            _.set(modalItem, path, value);
            updateModalItem(modalItem);
            refreshData();
        }, [modalItem, refreshData, translator]
    );

    const getUpgradeTypeList = useMemo(() => {
        const UpgradeTypeList = viewModelService?.productMetadata?.get('pc').types.getTypelist('HODwellingRoofUpdateType_TWIA');
        const formattedTypes =  UpgradeTypeList?.codes.map((code) => ({
                code: code.code,
                name: translator({ id: code.name })
            }))
        return formattedTypes
    },[translator, viewModelService?.productMetadata]);

    // DE15576
    const onSave = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'RoofDetails');
        } else {
            saveData(modalItem);
        }
       
    };

    const onCancel = () => {
        setDisplayError(false);
        isInvalid(true, 'RoofDetails');
        cancelData();
    }

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        roofUpdateType: {
            availableValues: getUpgradeTypeList
        },
        saveButtonId: {
            onClick: onSave
        },
        cancelButtonId: {
            onClick: onCancel
        },
        certificateOrStatement: {
            // DE15526
            required: !_.isUndefined(modalItem.roofUpdateDate) && !_.isUndefined(modalItem.roofUpdateDate.year) && (modalItem.roofUpdateDate.year >= 1988 || (!_.isUndefined(modalItem.roofUpdateDate.year.value) && modalItem.roofUpdateDate.year.value >= 1988)) ? true : false,
            visible: !_.isUndefined(modalItem.roofUpdateDate) && !_.isUndefined(modalItem.roofUpdateDate.year) && (modalItem.roofUpdateDate.year >= 1988 || (!_.isUndefined(modalItem.roofUpdateDate.year.value) && modalItem.roofUpdateDate.year.value >= 1988))? true : false
        },
        dateOfChange: {
            validationMessages: dateMismatchValidationMessage
        }
    }

    const resolvers = {
        resolveCallbackMap: {
        },
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent} 
            overrideProps={overrideProps}
            model={modalItem}
            showErrors={showErrors || displayError}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
        />
    )
}

RoofDetails.propTypes = {
    item: PropTypes.shape({}).isRequired,
    saveData: PropTypes.func.isRequired
};


export default RoofDetails